<template>
	<v-combobox
		class="ao-combobox"
	>
		<template #item="{ item, index, props }">
			<slot
				v-bind="{
					item,
					index,
					props,
				}"
				name="item"
			>
				<v-list-item
					v-bind="props"
				/>
			</slot>
		</template>
	</v-combobox>
</template>

<script setup></script>

<style lang="scss">
.ao-combobox {
	&.v-field {
		font-size: 12px;
	}
}
</style>
